import { useMutation } from '@tanstack/react-query';
import getAllStudiesStatisticsXLSX from '../api/getAllStudiesStatisticsXLSX';

const useGetStudiesStatisticsXLSX = (filters: { start: Date; end: Date; sortOrder: string }) => {
  const { data, mutateAsync, ...rest } = useMutation({
    mutationFn: () => getAllStudiesStatisticsXLSX(filters),
  });

  return {
    data,
    getAllStudiesStatisticsXLSX: mutateAsync,
    ...rest,
  };
};

export default useGetStudiesStatisticsXLSX;
